
<div mat-dialog-content class="content">
    <mat-spinner></mat-spinner>
    <div class="text">Sending Email</div>
</div>